import React from 'react';
import Label from '../../atoms/Label/Label';
import {iconsSvg} from '../../atoms/iconsSvg';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {gtmProductClick} from '../../services/gtmEvents';

const cdnUrl = process.env.RAZZLE_CDN || window.env.RAZZLE_CDN;
const CDN = cdnUrl + 'media/catalog/product';
const locale = (process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE).replace('_', '-');

const StyledBadge = styled.span`
  background: ${props => props.backColor};;
  color: ${props => props.fontColor};;
`;

const Card = ({product, cardType, label, backColor, fontColor, title, position, width = 0}) => {
  const labelElement = label.trim() !== ''
    ? <Label text={label} iconSvg={iconsSvg.discount} backColor={backColor} fontColor={fontColor}/>
    : '';

  const {t} = useTranslation();
  const companyLogo = false ? <div className="company-logo"/> : '';
  const condition = product.condicion;
  const discount = product.special_price;
  const discountText = product.special_price_text;
  const discountPercent = product.porcentaje_descuento_oferta;
  const shipping = undefined;
  const shippingFree = undefined;
  const location = [product.aviso_ciudad, product.aviso_provincia]
    .filter(l => l !== undefined && l.trim() !== '')
    .join(', ');
  const financing = product.hasFestival && product.financiacion_oferta
    ? <div className="financing-container">
      <div className="card-container">
        <div className="card-line"></div>
      </div>
      <span>{t('financing')}</span></div>
    : <span/>;

  const getCardSize = () => {
    let resolution = null;
    switch (cardType) {
      case 'card card-horizontal':
        resolution = '?d=265x265';
        break;
      case 'card card-mini':
        resolution = '?d=165x165';
        break;
      default:
        resolution = '?d=254x254';
        break;
    }
    return resolution;
  };

  const handleClick = (evt, url) => {
    gtmProductClick(product, position, title);
    if (width < 992) {
      evt.preventDefault();
      window.location = url;
    }
  };

  return (
    <div className={cardType}>
      {labelElement}
      <a href={width < 992 ? '' : product.url_key} onClick={(evt) => handleClick(evt, product.url_key)}>
        <div className={'img-style'}>
          <div className="box-top">
            <span className={'condition'}>{condition}</span>
          </div>
          <img src={CDN + product.image + getCardSize()} alt={product.imageName} loading="lazy" alt={product.name}/>
        </div>
        <div className={'company-info'}>
          {companyLogo}
          <div className={'company-name'}>{product.agroshopname}</div>
        </div>
        <div className={'product-info'}>
          <div className="main-info">
            <div className={'row1'}>
              {discount !== undefined && discount != 0.0 ?
                <>{product.moneda} {discountText}</>
                : (product.price !== undefined && product.price !== 0
                  ? <>{product.moneda} {product.priceText}</>
                  : <>
                    <div className="consult-price">{t('consult_price')}</div>
                  </>)
              }
            </div>
            <div className={'row2'}>
            <span className={'shipping'}>
              {shipping !== undefined
                ? <>{
                  shippingFree
                    ? <>{iconsSvg.discount} Envío Gratis</>
                    : ''
                }</>
                : ''
              }
            </span>
              <span className={'discount'}>
              {discount !== undefined && discount != 0.0
                ? <><span className="discount-value">{product.moneda} {product.priceText}</span></>
                : ''
              }
                {(discountPercent !== undefined && discountPercent > 0)
                  ? <StyledBadge className={'badge'} backColor={backColor} fontColor={fontColor}>{discountPercent}%
                    Off</StyledBadge>
                  : ''}
            </span>
              {(discountPercent !== undefined && discountPercent > 0)
                ? ''
                : <div className="line-container">
                  <hr/>
                </div>}
            </div>
            <h3 className={'row3'}>{product.name}</h3>
          </div>
          <div className={'row4'} title={location}>{location}</div>
        </div>
        <div className={!(product.financiacion_oferta) && cardType !== 'card' ?
          'bottom-description bottom-blank' :
          (!(product.financiacion_oferta || product.condicion) && cardType === 'card' ? 'bottom-description bottom-blank' : 'bottom-description')}>
          <span>{condition}</span>
          {financing}
        </div>
      </a>
    </div>);
};

export default Card;
